import React, { useEffect, useMemo, useState, useRef } from "react";
import {
  cleanAll,
  getAll,
  getAllProducer,
} from "../../store/reducers/userReducer";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  FlexRowBetween,
  Input,
  ListHolder,
  PlaceHolderImage,
  RespFont,
  TextWithPic,
  UserCard,
} from "../common/Style";
import {
  dateFormat,
  days,
  handleClickScroll,
} from "../common/others/Functions";
import FilledLoading from "../common/loader/FilledLoading";
import EditUser from "./EditUser";
import GenericModal from "../common/modals/GenericModal";
import logout from "../../assets/common/logout.svg";
import clear from "../../assets/common/clear.svg";
import plus from "../../assets/common/plus.svg";
import checklist1 from "../../assets/common/checklist1.svg";

import LogoutSpecipic from "../common/LogOut/LogoutSpecipic";
import BottomMenu from "../common/others/BottomMenu";
import { useHistory } from "react-router-dom";
import AddUser from "./AddUser";
import ClientRoutes from "../../navigation/Routes";

const MainProducer = () => {
  const [searchText, setSearchText] = useState("");
  const inputRef = useRef();

  let history = useHistory();
  const { users } = useSelector((state) => state.userReducer);
  const { user } = useSelector((state) => state.authReducer);
  const [loading, setLoading] = useState(false);
  const [user2edit, setUser2edit] = useState(false);
  const [showLogout, setShowLogout] = useState(false);
  const [showAddUser, setShowAddUser] = useState(false);

  const handleGetAllAfterAdd = async () => {
    setShowAddUser(false);
    handleGetAll();
  };

  const dispatch = useDispatch();

  const handleGetAll = async () => {
    setLoading(true);
    dispatch(getAllProducer()).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      setLoading(false);
    });
  };

  useEffect(() => {
    handleGetAll();
    return () => {
      dispatch(cleanAll());
    };
  }, []);

  useEffect(() => {
    setTimeout(function () {
      handleClickScroll("bla");
    }, 1000);
  }, []);

  let guestsArray = useMemo(() => {
    let arr = [];
    let sortedArr = [];
    if (Object.keys(users).length > 0)
      for (const [key, value] of Object.entries(users))
        if (
          searchText
            .toLowerCase()
            .split(" ")
            .filter((i) =>
              value.brideFN?.toLowerCase().includes(i.toLowerCase())
            ).length === searchText.toLowerCase().split(" ").length ||
          searchText
            .toLowerCase()
            .split(" ")
            .filter((i) =>
              value.groomFN?.toLowerCase().includes(i.toLowerCase())
            ).length === searchText.toLowerCase().split(" ").length ||
          searchText
            .toLowerCase()
            .split(" ")
            .filter((i) =>
              value.calendarName?.toLowerCase().includes(i.toLowerCase())
            ).length === searchText.toLowerCase().split(" ").length ||
          value.phone.includes(searchText) ||
          searchText === ""
        )
          sortedArr.push(value);
    let date = new Date();
    date.setHours(3);
    date.setMinutes(0);
    date.setSeconds(0);
    sortedArr.push({
      calendarName: "blablabla",
      date: date.toISOString(),
    });
    sortedArr.sort((a, b) => new Date(a["date"]) - new Date(b["date"]));

    for (let i = 0; i < sortedArr.length; i++) {
      if (sortedArr[i].calendarName === "blablabla")
        arr.push(
          <FlexRowBetween
            key={"bookmark"}
            style={{
              backgroundColor: "#7b96c4",
              height: "3px",
              marginTop: "10px",
            }}
            id={"bla"}
          />
        );
      else {
        if (sortedArr[i].seatupEventId == "besimple")
          if (!user.isItay) continue;
        arr.push(
          <UserCard
            border={
              sortedArr[i].isPaid
                ? "#7b96c4"
                : days(new Date(), new Date(sortedArr[i].date)) >= 4
                ? "#ec7070"
                : "none"
            }
            borderR={sortedArr[i].isDigitalSeat ? "#8ac47b" : "none"}
            key={i}
            onClick={() => setUser2edit(sortedArr[i])}
          >
            <RespFont>
              {sortedArr[i].eventType
                ? `${sortedArr[i].brideFN} ו${sortedArr[i].groomFN}`
                : sortedArr[i].calendarName}
            </RespFont>
            <RespFont>
              {dateFormat(
                sortedArr[i].hour1 === ""
                  ? "אין פרטים"
                  : sortedArr[i].hour1 + ", " + sortedArr[i].hall
              )}
            </RespFont>
            <RespFont>{dateFormat(sortedArr[i].date)}</RespFont>
          </UserCard>
        );
      }
    }

    return arr;
  }, [users, searchText]);

  return (
    <div
      style={{
        width: "100%",
        height: `${window.screen.availHeight}px`,
      }}
    >
      <BottomMenu
        data={[
          <img
            key={2}
            src={checklist1}
            alt="checklist1"
            style={{ width: "31px", padding: "10px 0", cursor: "pointer" }}
            onClick={() => history.push(ClientRoutes.Producer.todos)}
          />,
          <img
            key={3}
            src={plus}
            alt="plus"
            style={{ width: "31px", padding: "10px 0", cursor: "pointer" }}
            onClick={() => setShowAddUser(true)}
          />,
          <img
            key={4}
            src={logout}
            alt="logout"
            style={{ width: "31px", padding: "10px 0", cursor: "pointer" }}
            onClick={() => setShowLogout(true)}
          />,
        ]}
      />
      <FlexRowBetween
        style={{
          background: "#f2f2f2",
          padding: "10px 10px",
          position: "fixed",
          boxShadow: "0 2px 4px #b3b2b2",
        }}
      >
        <div
          style={{
            position: "relative",
            marginRight: "0px",
            width: "150px",
          }}
        >
          <PlaceHolderImage
            onClick={() => {
              setSearchText("");
              inputRef.current.focus();
            }}
            fontSize={`28px`}
            top={`50%`}
            src={clear}
            alt="clear"
            style={{
              cursor: "pointer",
              border: "1px solid silver",
              padding: "5px",
              borderRadius: "2px",
              left: "7px",
            }}
          />
          <Input
            value={searchText}
            ref={inputRef}
            type="text"
            placeholder="חיפוש"
            name="value"
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              padding: "7px 0px",
              paddingRight: "3px",
              border: "1px solid silver",
            }}
            // let tempPhone = phone.replaceAll(/[^\d]/g, "");
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
      </FlexRowBetween>
      <div style={{ height: "70px" }} />
      <ListHolder>{guestsArray}</ListHolder>
      <div style={{ height: "70px" }} />

      {loading && <FilledLoading />}
      {user2edit && (
        <GenericModal
          init={setUser2edit}
          div={
            <EditUser user={user2edit} init={setUser2edit} up={user.producer} />
          }
        />
      )}
      {showAddUser && (
        <GenericModal
          init={setShowAddUser}
          div={<AddUser init={handleGetAllAfterAdd} />}
        />
      )}
      {showLogout && (
        <GenericModal
          init={setShowLogout}
          div={<LogoutSpecipic init={setShowLogout} />}
        />
      )}
    </div>
  );
};

export default MainProducer;
